import { render } from "./DarkModeToggle.vue?vue&type=template&id=2381f333&scoped=true"
import script from "./DarkModeToggle.vue?vue&type=script&lang=js"
export * from "./DarkModeToggle.vue?vue&type=script&lang=js"

import "./DarkModeToggle.vue?vue&type=style&index=0&id=2381f333&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1672060877/src/vivamo-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2381f333"]])

export default __exports__